import { Textbox, SelectMenu, Checkbox, Button, Popup } from 'components/generic';
import { useContext, useState, useEffect } from 'react';
import { getValueById, getValuesById, requestValidator } from 'utils';
import { OnboardingContext } from 'providers/onboarding-provider';
import { useFetch } from 'hooks';
import { useNavigate } from 'react-router-dom';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';
import './style.scss';

const emailDomainRegex = /(?<=\@)(.*?)(?=\.)/;

const ClientSignup = () => {
	const context = useContext(OnboardingContext);
	const [terms, setTerms] = useState({});
	const [errorMsg, setErrorMsg] = useState();
	const [countryCodes, setCountryCodes] = useState({});
	const [signupObj, setSignupObj] = useState({});
	const [signupValidation, setSignupValidation] = useState(false);

	const navigate = useNavigate();
	const api = useFetch();

	// referenceData api call
	const referenceDataAPI = async () => {
		const { data } = await api({ url: 'referenceData/v1/onboarding', method: 'get' });
		setTerms(prevState => ({ ...prevState, displayValue: getValueById(data?.data, 'rd_onboardingTC')?.value[0]?.value }));
		setCountryCodes(prevState => ({ ...prevState, countryList: getValueById(data?.data, 'rd_countryCodes')?.value }));
	};

	useEffect(() => {
		localStorage.clear();
		referenceDataAPI();
	}, []);

	// validation for signup
	useEffect(() => {
		setSignupValidation(requestValidator({ ...signupObj, validatorKey: 'onboardingSignup' }));
	}, [signupObj]);

	// Signup api call
	const handleOnboarding = async () => {
		try {
			const data = { ...signupObj, c_mobileNumber: countryCodes?.selectedCountry?.phone_code + signupObj?.c_mobileNumber, c_timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone };
			await api({ url: 'client/v1/signup', method: 'post', data, hideErrorToaster: true });
			context.setEmailStatus('PEN');
			navigate('/verify');
		} catch (error) {
			setErrorMsg(error);
		}
	};

	// setting createobj for signup
	const handleSignupData = (e, key) => {
		key === 'c_country' && countryCodes?.countryList?.find(el => el?.key === e && setCountryCodes(prevState => ({ ...prevState, selectedCountry: el })));
		key === 'c_workEmail' && setCreateObj(e?.match(emailDomainRegex)?.at()?.toLowerCase(), 'c_emailDomain');
		setCreateObj(e, key);
	};

	const setCreateObj = (value, key) => {
		setSignupObj(prevState => {
			const data = cloneDeep(prevState);
			data[key] = value;
			return data;
		});
	};

	// password validation
	const checkPassword = () => {
		const check = signupObj?.c_password !== signupObj?.c_rePassword;
		setErrorMsg(check ? 'Password does not match' : null);
		signupObj?.c_password === signupObj?.c_rePassword && handleOnboarding();
	};

	// toaster message for errors
	const toaster = errorMsg && (
		<div className='client-signup__error'>
			<img src={Images?.error_alert} />
			<span>{errorMsg}</span>
		</div>
	);

	// terms and conditions popup
	const termsPopup = (
		<Popup onClose={() => setTerms(prevState => ({ ...prevState, showTerms: false }))} popupState={terms?.showTerms}>
			<div className='client-signup__terms'>
				<h3>Terms & Conditions</h3>
				<p>{terms?.displayValue}</p>
			</div>
		</Popup>
	);

	return (
		<div className='client-signup scroll-bar'>
			<h1>Signup</h1>
			{toaster}

			<Textbox type='email' label='Work Email' infoContent='Enter Work Email' placeholder='Enter Email ID' value={signupObj?.c_workEmail} onChange={e => handleSignupData(e?.target?.value, 'c_workEmail')} />

			<Textbox label='Company Name' placeholder='Enter Company Name' infoContent='Enter Company Name' value={signupObj?.c_name} onChange={e => handleSignupData(e?.target?.value, 'c_name')} />

			<SelectMenu label='Country' mandatory infoContent='Select the country' menuOptions={countryCodes?.countryList || []} placeholder='Select' value={getValuesById(countryCodes?.countryList, signupObj?.c_country)} onChange={e => handleSignupData(e, 'c_country')} />

			<Textbox
				type='number'
				label='Mobile Number'
				infoContent='Enter Mobile Number'
				placeholder='Enter Mobile Number'
				prefix={countryCodes?.selectedCountry?.phone_code}
				prefixValue={countryCodes?.selectedCountry?.phone_code}
				onChange={e => handleSignupData(e?.target?.value, 'c_mobileNumber')}
				value={signupObj?.c_mobileNumber}
			/>

			<Textbox
				label='Username'
				placeholder='Enter username'
				infoContent='Enter username'
				value={signupObj?.c_username}
				suffix={signupObj?.c_emailDomain && countryCodes?.selectedCountry?.key}
				suffixValue={`_${signupObj?.c_emailDomain}${countryCodes?.selectedCountry?.key}`}
				onChange={e => handleSignupData(e?.target?.value, 'c_username')}
			/>

			<Textbox type='password' label='Password' placeholder='Enter Password' infoContent='Enter Password' maxlength={16} onChange={e => handleSignupData(e?.target?.value, 'c_password')} value={signupObj?.c_password} />

			<Textbox type='password' label='Re-enter Password' placeholder='Re-enter Password' infoContent='Re-enter Password' maxlength={16} onChange={e => handleSignupData(e?.target?.value, 'c_rePassword')} value={signupObj?.c_rePassword} />

			<Checkbox
				content='I agree to the'
				link='Terms & Conditions'
				checked={terms?.checked}
				onClick={e => setTerms(prevState => ({ ...prevState, checked: e?.target?.checked }))}
				onLink={() => setTerms(prevState => ({ ...prevState, showTerms: true }))}
			/>

			<Button label="Let's start" primary full handleOnSubmit={checkPassword} disabled={signupValidation || !terms?.checked} />

			<div className='client-signup__account'>
				Already a member?
				<span className='hyperlink client-signup__left' onClick={() => context.setSignupToggler('SIGNIN')}>
					Signin
				</span>
			</div>

			<p className='client-signup__copyrights'> &copy; 2022 Zeal, inc. All rights reserved</p>
			{termsPopup}
		</div>
	);
};

export default ClientSignup;
